import { render, staticRenderFns } from "./auto-block-dialog.vue?vue&type=template&id=328b375e&scoped=true&"
import script from "./auto-block-dialog.vue?vue&type=script&lang=js&"
export * from "./auto-block-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b375e",
  null
  
)

export default component.exports